import apiClient from '../utils/apiClient'
import { actions } from './actionTypes'

export const getSignedDocs = (doc) => (dispatch, getState) => {
  const options = {
    method: 'GET',
    url: `${process.env.REACT_APP_API}/api/docs/signed/${doc}`
  }

  apiClient(options).then(
    response =>
      dispatch({ type: actions.GET_SIGNED_DOCS, payload: response.data }),
    error => console.log(error)
  )
}

export const deleteSignedDoc = (signedId) => {
  return apiClient({
    method: 'DELETE',
    url: `${process.env.REACT_APP_API}/api/doc/signed/${signedId}`
  })
}

export const updateSignedProcessed = (signedId, processed) => {
  return apiClient({
    method: 'PATCH',
    url: `${process.env.REACT_APP_API}/api/doc/signed/${signedId}`,
    data: { processed }
  })
}

export const getSignedFileBlob = (mongoDbId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      url: `${process.env.REACT_APP_API}/api/doc/signed/${mongoDbId}`,
      responseType: 'blob'
    }

    apiClient(options).then(
      response => resolve(response.data),
      error => reject(error)
    )
  })
}

export const startBundleDownload = (mongoDbId, { start, end } = {}) => {
  return new Promise((resolve, reject) => {
    const params = {}
    if (start) params.start = start
    if (end) params.end = end

    const options = {
      method: 'POST',
      url: `${process.env.REACT_APP_API}/api/doc/bundle/start/${mongoDbId}`,
      params
    }

    apiClient(options).then(
      response => resolve(response.data),
      error => reject(error)
    )
  })
}

export const queryBundleDownloadProgress = (jobId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      url: `${process.env.REACT_APP_API}/api/doc/bundle/progress/${jobId}`
    }

    apiClient(options).then(
      response => resolve(response.data),
      error => reject(error)
    )
  })
}

export const getCompletedBundleDownload = (jobId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      url: `${process.env.REACT_APP_API}/api/doc/bundle/download/${jobId}`,
      responseType: 'blob'
    }

    apiClient(options).then(
      response => resolve(response.data),
      error => reject(error)
    )
  })
}
